import * as R from "ramda";
import { isRefAreaDimension } from "./isRefAreaDimension.mjs";
const getRefAreaDimension = ({ dimensions }) => R.find(isRefAreaDimension, dimensions);
export {
  getRefAreaDimension
};
